/** Inline notice used for data caveats and API error codes. */

import { useTranslation } from 'react-i18next';

interface Props {
  tone?: 'info' | 'warning' | 'error';
  code?: string | null;
  params?: Record<string, unknown>;
  children?: React.ReactNode;
}

export function Notice({ tone = 'info', code, params, children }: Props) {
  const { t } = useTranslation();
  if (!code && !children) return null;
  const text = code
    ? t([`errors.${code}`, 'errors.generic'], { code, ...(params ?? {}) })
    : null;
  return (
    <p className={`notice notice--${tone}`} role={tone === 'error' ? 'alert' : undefined}>
      {text ?? children}
    </p>
  );
}
